import React from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { getPolyglot } from '../../../../../../i18n';
import {
  RouterComponentProps,
  withRouter,
} from '../../../../../../util/route-dom';
import { useControlUnitsById } from '../../../../../../redux/controlUnit/hooks/useControlUnitsById';
import ControlUnitsList from '../../../../ControlUnit/ControlUnitsList/ControlUnitsList';
import useControlUnitsOverviewRouteGuard from '../../../../ControlUnit/useControlUnitsOverviewRouteGuard';
import { Navigate, useParams } from 'react-router-dom';
import useWatchError from '../../../../../../handlingErrors/useWatchError';

export interface QueryParams extends Record<string, string> {
  groupId: string;
  deviceId: string;
}

interface DeviceOverviewPageSimpleProps
  extends RouterComponentProps<QueryParams> {}

export function DeviceOverviewPageSimple(props: DeviceOverviewPageSimpleProps) {
  const {
    params: { deviceId = '', groupId },
  } = props;
  const params = useParams<QueryParams>();
  const polyglot = getPolyglot();
  const {
    data: controlUnits,
    error: controlUnitsError,
    isLoading: loadingControlUnits,
  } = useControlUnitsById({
    deviceId: deviceId,
    hideCommander: true,
  });
  useWatchError(controlUnitsError);

  const { enabled, url } = useControlUnitsOverviewRouteGuard();
  if (!enabled) {
    return <Navigate to={url} replace />;
  }

  if (loadingControlUnits)
    return (
      <Box textAlign={'center'} margin={2}>
        <CircularProgress />
      </Box>
    );
  if (!controlUnits) return null;
  if (controlUnits.length === 0)
    return (
      <Box margin={2}>
        <Alert severity="warning">
          {polyglot.t('device.controlUnit.empty')}
        </Alert>
      </Box>
    );

  return (
    <Box
      className={'DeviceOverviewPageSimple'}
      sx={{
        backgroundColor: 'background.default',
      }}
    >
      <ControlUnitsList
        controlUnits={controlUnits}
        deviceId={deviceId}
        groupId={groupId}
      />
    </Box>
  );
}

export default withRouter(DeviceOverviewPageSimple);
